import { SurveyAction } from './list/survey-action';

export const menuItemList = [
    { action: SurveyAction.View, title: 'View' },
    { action: SurveyAction.GetPDF, title: 'Get PDF' },
    { action: SurveyAction.MarkAppointmentBooked, title: 'Mark Appointment Booked' },
    { action: SurveyAction.MarkComplete, title: 'Mark Complete' },
    { action: SurveyAction.FollowUpUnsuccessful, title: 'Follow-Up Unsuccessful' },
    { action: SurveyAction.UploadRequisition, title: 'Upload Requisition' },
    { action: SurveyAction.RequisionAlreadySent, title: 'Requisition Already Sent' },
    { action: SurveyAction.PhoneInterviewSurvey, title: 'Phone Interview Survey' },
    { action: SurveyAction.ResendSurveyEmail, title: 'Resend Survey Email' },
    { action: -1, title: '' }
];